import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import "../CustomStyle.css";
import logo from "../assets/TraQR_logo.png";
import "bootstrap-icons/font/bootstrap-icons.css";

const Navbar = ({ userRole, signOutRedirect }) => {
  const navbarCollapseRef = useRef(null);

  const handleNavClick = () => {
    const toggler = document.querySelector(".navbar-toggler");
    if (
      window.innerWidth < 992 &&
      toggler?.getAttribute("aria-expanded") === "true"
    ) {
      toggler.click();
    }
  };

  const renderAdminLinks = () => (
    <>
      <li className="nav-item">
        <NavLink
          to="/users"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Users</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          to="/print_collaterals"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Print Collaterals</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink
          to="/activity_logs"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Activity Logs</span>
        </NavLink>
      </li>
    </>
  );

  const renderCustomerLinks = () => (
    <>
      <li className="nav-item custom-border-bottom ">
        <NavLink
          to="/campaigns"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="create-campaign-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Campaigns</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom ">
        <NavLink
          to="/contacts"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="upload-contacts-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Contacts</span>

        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <NavLink
          to="/proof_templates"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="proof-template-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active"> Proof Templates</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <NavLink
          to="/print_collaterals"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="print-collaterals-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active"> Print Collaterals</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            isActive ? "nav-link custom-nav-link active" : "nav-link custom-nav-link"
          }
          data-testid="campaign-dashboard-link"
          onClick={handleNavClick}
        >
          <span className="underline-on-active">Dashboard</span>
        </NavLink>
      </li>
      <li className="nav-item custom-border-bottom">
        <a
          href={process.env.REACT_APP_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link custom-nav-link"
          style={{
            display: "block",
          }}
          data-testid="contact-support-link"
          onClick={handleNavClick}
        >
          Support
          <i
            className="bi bi-box-arrow-up-right"
            style={{ marginLeft: "5px" }}
          ></i>
        </a>
      </li>
    </>
  );

  return (
    <nav className="navbar navbar-expand-lg fixed-top bg-white shadow-sm border-bottom">
      <NavLink className="navbar-brand ms-2" to="/" >
        <img src={logo} width="100" height="auto" alt="TraQR Logo" />
      </NavLink>
      <button
        className="navbar-toggler me-3"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className="collapse navbar-collapse custom-menu"
        id="navbarNavDropdown"
        ref={navbarCollapseRef}
      >
        <ul className="navbar-nav ms-3 ms-lg-auto me-2">
          {userRole === "admin" ? renderAdminLinks() : renderCustomerLinks()}
          <li className="nav-item">
            <button
              onClick={() => {
                signOutRedirect();
              }}
              className="btn btn-danger ms-lg-3"
              data-testid="sign-out-button"
            >
              Sign Out
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
